/** Shared course-domain picker (Quiz My Titles + Presentation Maker slide picker). */

export const CATALOGUE_FAVORITE_KEY = "microlab.courseCatalog.favoriteCatalogue";

const CATALOGUE_TITLE_KEYS = {
  all: "pages.presentationMaker.catalogueAll",
  histology: "pages.presentationMaker.catalogueHistology",
  embryology: "pages.presentationMaker.catalogueEmbryology",
  anatomy: "pages.presentationMaker.catalogueAnatomy",
};

export const SYSTEM_CATALOGUE_OPTIONS = [
  { key: "all", title: "All", titleKey: CATALOGUE_TITLE_KEYS.all, apiTypes: ["his", "emb", "anatomy"] },
  { key: "histology", title: "Histology", titleKey: CATALOGUE_TITLE_KEYS.histology, apiTypes: ["his"] },
  { key: "embryology", title: "Embryology", titleKey: CATALOGUE_TITLE_KEYS.embryology, apiTypes: ["emb"] },
  { key: "anatomy", title: "Anatomy", titleKey: CATALOGUE_TITLE_KEYS.anatomy, apiTypes: ["anatomy"] },
];

export const SPECIFIC_CATALOGUE_OPTIONS = SYSTEM_CATALOGUE_OPTIONS.filter(
  (o) => o.key !== "all"
);

/** Resolve catalogue option label for the active UI language. */
export function catalogueOptionTitle(opt, t) {
  if (!opt) return "";
  if (typeof t === "function" && opt.titleKey) return t(opt.titleKey);
  return opt.title || "";
}

export function readFavoriteCatalogueKey(fallback = "histology") {
  try {
    const fav = localStorage.getItem(CATALOGUE_FAVORITE_KEY) || fallback;
    return SYSTEM_CATALOGUE_OPTIONS.some((o) => o.key === fav) ? fav : fallback;
  } catch (_) {
    return fallback;
  }
}

export function writeFavoriteCatalogueKey(key) {
  const next = SYSTEM_CATALOGUE_OPTIONS.some((o) => o.key === key)
    ? key
    : "histology";
  try {
    localStorage.setItem(CATALOGUE_FAVORITE_KEY, next);
  } catch (_) {
    /* ignore */
  }
  return next;
}

export function catalogueOptionByKey(key) {
  return SYSTEM_CATALOGUE_OPTIONS.find((o) => o.key === key) || null;
}

export function apiTypeToSourceLabel(apiType, t) {
  if (apiType === "his") {
    return typeof t === "function"
      ? t("pages.presentationMaker.catalogueHistology")
      : "Histology";
  }
  if (apiType === "emb") {
    return typeof t === "function"
      ? t("pages.presentationMaker.catalogueEmbryology")
      : "Embryology";
  }
  if (apiType === "anatomy") {
    return typeof t === "function"
      ? t("pages.presentationMaker.catalogueAnatomy")
      : "Anatomy";
  }
  return typeof t === "function" ? t("pages.presentationMaker.course") : "Course";
}
